module.exports = __webpack_public_path__ + "img/user.b4e51c2b.png";